import React from 'react';
import LoginComponent from './LoginComponent';
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { t } = useTranslation();

    const tr = (key) => {
        return t(`login:${key}`);
    };

    return (
        <>

            <div className="flex justify-center min-h-screen">
                <div className="w-full max-w-md ">
                    <LoginComponent tr={tr} />
                </div>
            </div>
        </>
    );
};

export default Login;
